import { ArticleHeading0, ArticleHeading1, ArticleHeading2, ArticleHeading3, ArticleHeading4, ArticleHeading5, ArticleHeading6 } from '../Article/ArticleHeading';

/**
 * @deprecated используйте ArticleHeading0 или UIHeading0
 */
export const Header0 = ArticleHeading0;

/**
 * @deprecated используйте ArticleHeading1 или UIHeading1
 */
export const Header1 = ArticleHeading1;

/**
 * @deprecated используйте ArticleHeading2 или UIHeading2
 */
export const Header2 = ArticleHeading2;

/**
 * @deprecated используйте ArticleHeading3 или UIHeading3
 */
export const Header3 = ArticleHeading3;

/**
 * @deprecated используйте ArticleHeading4 или UIHeading4
 */
export const Header4 = ArticleHeading4;

/**
 * @deprecated используйте ArticleHeading5 или UIHeading5
 */
export const Header5 = ArticleHeading5;

/**
 * @deprecated используйте ArticleHeading6 или UIHeading6
 */
export const Header6 = ArticleHeading6;